import React from "react";
import classes from "./TabsulQsType.module.css";
import logo from "../Assets/green.png" // adjust path if needed
import { useNavigate, useParams } from "react-router-dom";

const TabsulQsType = () => {

    const navigate = useNavigate();
    const { id } = useParams();

  const handleStart = (qs) => {
    navigate(`/mocktest/${id}/${qs}`);
  };

  return (
    <div className={classes.container}>
      {/* Hero Section */}
      <section className={classes.hero}>
        <img src={logo} alt="Tabsul Logo" className={classes.heroLogo} />

        <p className={classes.heroText}>
          Choose your preferred quiz format and test your knowledge.
        </p>
      </section>

      {/* Title */}
      {/* <h1 className={classes.title}>Start Your Quiz</h1> */}

      {/* Options */}
      <div className={classes.optionsContainer}>
        {/* 100 Questions */}
        <div className={classes.card}>
          <h2 className={classes.cardTitle}>Full Test</h2>
          <p className={classes.cardText}>
            100 Questions • 120 Minutes
          </p>
          <button
            className={classes.button}
            onClick={() => handleStart(100)}
          >
            Start
          </button>
        </div>

        {/* 50 Questions */}
        <div className={classes.card}>
          <h2 className={classes.cardTitle}>Half Test</h2>
          <p className={classes.cardText}>
            50 Questions • 60 Minutes
          </p>
          <button
            className={classes.button}
            onClick={() => handleStart(50)}
          >
            Start
          </button>
        </div>

        {/* 20 Questions */}
        <div className={classes.card}>
          <h2 className={classes.cardTitle}>Quick Test</h2>
          <p className={classes.cardText}>
            20 Questions • 20 Minutes
          </p>
          <button
            className={classes.button}
            onClick={() => handleStart(20)}
          >
            Start
          </button>
        </div>
      </div>
    </div>
  );
};

export default TabsulQsType;